var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.94 625.57C339.482 482.027 483.025 338.485 626.568 194.942C678.894 142.616 757.383 221.105 705.057 273.431C561.514 416.974 417.971 560.516 274.429 704.059C222.103 756.385 143.614 677.896 195.94 625.57Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.428 194.942C417.971 338.484 561.513 482.027 705.056 625.57C757.382 677.896 678.893 756.384 626.567 704.059C483.025 560.516 339.482 416.973 195.939 273.431C143.613 221.105 222.102 142.616 274.428 194.942Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1be2bb218ca181ebdc380268b1185fa0.svg";
export { ForwardRef as ReactComponent };